import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils'

type Props = {
  size?: number | string
}

export const AuroraCouplesAndFamilyTherapySpotIllustration: FunctionComponent<Props> = ({ size = 96 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path
        d='M32.225 0.239258C27.8073 0.239258 23.5212 0.996819 19.4855 2.49044C9.87754 6.05186 3.12272 13.9474 0.952482 24.1524C-0.481698 30.806 -0.298315 36.9601 1.51654 42.9574C3.83349 50.6164 9.52089 57.0753 17.1205 60.6772C20.8932 62.4693 25.2273 63.4925 30.0003 63.7176C30.6137 63.7454 31.2372 63.7606 31.8569 63.7606C35.6865 63.7606 39.5388 63.2357 43.3076 62.2012C43.5972 62.1291 43.8729 62.0545 44.1638 61.9685C47.5507 60.9769 50.5987 59.4087 53.2065 57.3131C56.0382 55.0505 58.369 52.1822 60.127 48.7927C60.4735 48.125 60.8049 47.4218 61.1704 46.5808C63.1812 41.9114 64.1525 36.6844 63.9805 31.4586C63.8996 29.148 63.5556 26.6919 62.9612 24.1524C61.9823 20.032 60.3862 16.1569 58.345 12.9395C57.786 12.0757 57.2725 11.3497 56.7641 10.6971C53.0952 5.9646 47.3787 2.64347 40.2382 1.098C37.6151 0.528876 34.9188 0.240522 32.2262 0.240522L32.225 0.239258Z'
        fill='white'
        fillOpacity='0.4'
      />
      <Path
        d='M36.7237 36.4086C36.6319 36.5694 36.5316 36.7302 36.4272 36.8868C33.6397 41.0337 27.175 46.7612 25.0264 46.9972C24.0095 47.1099 17.5386 41.9357 14.5317 36.5339C12.8488 33.5062 12.2474 30.4096 14.3125 28.1252C16.1625 26.081 18.1128 25.7239 19.8584 26.1061C22.9989 26.7889 25.4691 29.8688 25.4691 29.8688C25.4691 29.8688 26.6572 28.4551 28.5239 27.5594C28.5427 27.5949 28.5636 27.6283 28.5845 27.6638C30.6579 31.1801 34.2389 34.5586 36.7237 36.4086Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M36.7213 36.409C34.2365 34.5589 30.6555 31.1804 28.582 27.6641C28.5612 27.6286 28.5403 27.5952 28.5215 27.5597C30.3277 26.6932 32.7728 26.3152 35.3871 28.1882C37.8865 29.9777 38.3208 33.5817 36.7213 36.409Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M50.4846 27.4673C47.8014 31.6852 41.4829 37.5715 39.3406 37.8596C38.996 37.9056 38.0063 37.3585 36.7263 36.4063C38.3258 33.5791 37.8915 29.9751 35.392 28.1856C32.7778 26.3126 30.3326 26.6906 28.5265 27.5571C26.8143 24.6088 26.1732 21.5706 28.159 19.2633C29.9568 17.1731 31.8966 16.7681 33.6506 17.1042C36.8078 17.7098 39.3552 20.727 39.3552 20.727C39.3552 20.727 43.8237 15.1289 49.2297 18.7997C51.9212 20.6247 52.3513 24.5357 50.4846 27.4673Z'
        fill={spotIllustration.primary.fill}
      />
    </Svg>
  )
}
